import { makeResolveInstance } from '@/shared/factories/helpers/make-resolve-instance';

export const resolveAdsGramInstance = makeResolveInstance(() => window.Adsgram);
